<template>
    <div class="customer_service" :class="isCollapse?'open':'close'" @click="onOpen" v-show="isShow">
        <img class="customer_service--bg" src="../../../assets/img/b2b/sgif_bg2@3x.png" v-if="isCollapse" @click="jumpMin">
        <img class="customer_service--img" src="../../../assets/img/b2b/sgif_bg1@3x.png" @click="jumpMin">
        <img class="customer_service--icon" src="../../../assets/img/b2b/sgif_icon@3x.png" @click="jumpMin">
    </div>
</template>
<script>
// 在线客服
import { versions } from '../../common/version'
const CustomerService = {
    name: 'customerService',
    props: {
        goodInfo: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            isCollapse: true,
            isShow: false
        }
    },
    created () {
        if (this.initAppVer()) {
            this.isShow = true
        }
    },
    mounted () {
        window.addEventListener('scroll', () => {
            if (this.isCollapse) {
                this.isCollapse = true
            }
        })
    },
    methods: {
        onOpen () {
            this.isCollapse = this.isCollapse
        },
        initAppVer (type) {
            let appVer = localStorage.getItem('appVer')
            if (appVer) {
                appVer = appVer.split('.')
                let nowVer = type ? [5000000, 20000, 400] : [5000000, 20000, 200]
                let minVer = [5000000, 20000, 400]
                let nowFlas = [5000000, 20000, 700]
                const [a, b, c] = appVer
                appVer = [a * 1000000, b * 10000, c * 100]
                let _nowVer = nowVer.reduce((a, b) => a + b)
                let _appVer = appVer.reduce((a, b) => a + b)
                let _nowFlas = nowFlas.reduce((a, b) => a + b)
                let _minVer = minVer.reduce((a, b) => a + b)
                if (!type) {
                    return _appVer >= _nowVer
                }
                if (_appVer < _minVer) {
                    return false
                } else if (_appVer < _nowFlas) {
                    return true
                } else {
                    if (type === 2) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        },
        jumpMin () {
            if (this.initAppVer(1)) {
                if (versions().ios || versions().iPhone || versions().iPad) {
                    window.webkit.messageHandlers.dfxB2b.postMessage({
                        'method': 'customerService'
                    })
                } else {
                    window.kfxt.customerService()
                }
            } else if (this.initAppVer(2)) {
                if (versions().ios || versions().iPhone || versions().iPad) {
                    window.webkit.messageHandlers.dfxB2b.postMessage({
                        'method': 'customerService',
                        'cardImage': this.goodInfo && this.goodInfo.cardImage,
                        'cardHeader': this.goodInfo && this.goodInfo.cardHeader,
                        'cardSubhead': this.goodInfo && this.goodInfo.cardSubhead,
                        'cardPrice': this.goodInfo && this.goodInfo.cardPrice,
                        'cardUrl': this.goodInfo && this.goodInfo.cardUrl
                    })
                } else {
                    window.kfxt.customerService(this.goodInfo && JSON.stringify(this.goodInfo))
                }
            } else if (this.isCollapse) {
                if (versions().ios || versions().iPhone || versions().iPad) {
                    window.webkit.messageHandlers.dfxB2b.postMessage({
                        'method': 'launchMiniProgram',
                        'userName': 'gh_a009e26f070f',
                        'path': 'users/pages/customerService/index'
                    })
                } else {
                    window.kfxt.launchMiniProgram('gh_a009e26f070f', 'users/pages/customerService/index')
                }
            }
        }
    }
}
export default CustomerService
</script>
<style lang="scss" scoped>
.customer_service {
    position: fixed;
    height: 140px;
    z-index: 999;
    &--bg {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    &--img {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    &--icon {
        position: absolute;
    }
}

.open {
    &.customer_service {
        bottom: 132px;
        right: 0;
        width: 140px;
        transition-duration: 0.3s;
        transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
    }

    .customer_service--icon {
        top: 20px;
        left: 42px;
        width: 52px;
        height: 52px;
    }
}

.close {
    &.customer_service {
        bottom: 154px;
        right: -40px;
        width: 98px;
        transform: rotateZ(-90deg);
        transition-duration: 0.3s;
        transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
    }

    .customer_service--icon {
        top: 28px;
        left: 30px;
        width: 42px;
        height: 42px;
        transform: rotateZ(90deg);
    }
}
</style>
